import DATA_TYPES from "../modules/product_attributes/enums/DATA_TYPES";
import { formatNumberToDecimalString} from '@/services/formatter_services/decimal-formatter';
import i18n from "../language/i18n";

export const formatBool = value => value === true ? i18n.t('Common.yes') : value === false ? i18n.t('Common.no') : '';
export const formatBoolDefaultFalse = value => value === true ? i18n.t('Common.yes') : value === false ? i18n.t('Common.no') : i18n.t('Common.no');
export const formatNumberToBool = value => value == 1;
export const hideZero = value => value === 0 ? '' : value;

export const numberToPercent = value => value ? ((value * 100).toFixed(2) + '%').replace('.', ',') : '-';

export const formatAddressStringWithCommas = (addressString) => {
  if (addressString == undefined) { return undefined }
  return addressString.replace(/,/g, '\n');
}

export const formatArrayToString = items => {
  if (Array.isArray(items)){
    return items.join();
  }
  return items
};

export const formatDataType = value => DATA_TYPES[value].text;

export const formatDiscreteDataValues = (value, item) => {
  if (!value) return value
  if (item.type === DATA_TYPES.BOOLEAN.value)
    return value.map(v => formatBool(v === 'false'))
  else if(item.type === DATA_TYPES.BIG_DECIMAL.value)
    return value.map(v => formatNumberToDecimalString(v))
  return value
};

export const commaStringToArray = commaString => commaString?.split(',');

export const formatStringToArray = commaString => commaString?.split(', ');

export const formatStringRemoveParagraphs = value => value.replace(/<\/?p>/g, ' ');

export const compareId = (id1, id2) => id1 == id2;

export const getDeepObjectValue = (obj, path) => {
  if(obj === undefined || obj === null || path == undefined) return undefined;
  const splitPath = path.split('.').filter(path => path);
  for (var i=0, len=splitPath.length; i<len; i++){
    if(obj === undefined || obj === null) return obj;
    obj = obj[splitPath[i]];
  };
  return obj;
};

export const formatBlobAsJson = async blob => JSON.parse(await new Response(blob).text());
